import { ErrorBoundary } from '@/pages/time-off-calendar/user/employee-calendar.error';

export default ErrorBoundary;
